module.exports = __webpack_public_path__ + "img/canada-blood-diseases-male.6d8b385f.png";